import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    DefaultDataService,
    DefaultDataServiceConfig,
    DefaultDataServiceFactory,
    EntityCollectionDataService,
    HttpUrlGenerator,
    Update
} from 'ngrx-data';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResponseMapper } from '../utils/response-mapper';
import { IBackendQueryParams } from '../interfaces';

@Injectable()
export class ChassisDataService<T> extends DefaultDataService<T> {

    protected query: IBackendQueryParams = {};

    constructor(entityName: string, http: HttpClient, httpUrlGenerator: HttpUrlGenerator, config: DefaultDataServiceConfig) {
        super(entityName, http, httpUrlGenerator, config);
        this.entityUrl = this.entitiesUrl;
    }

    // public getAll(): Observable<T[]> {
    //     return super
    //         .getAll()
    //         .pipe(map((response: any) => response.resources.map(resource => this.mapGetResponse(resource))));
    // }

    public getById(id: string | number): Observable<T> {
        return super
            .getById(id)
            .pipe(map((response: any) => this.mapGetResponse(response.resource)));
    }

    // public getWithQuery(params: string | QueryParams): Observable<T[]> {
    //     return super
    //         .getWithQuery(params)
    //         .pipe(
    //             tap(response => {
    //                 console.log('response from api', response);
    //             }),
    //             map((response: any) => response.resources.map(resource => this.mapResponse(resource)))
    //         );
    // }

    add(entity: T): Observable<T> {
        return super
            .add(entity)
            .pipe(map((response: any) => this.mapUpsertResponse(response.resource)));
    }


    update(update: Update<T>): Observable<T> {
        return super
            .update(update)
            .pipe(map((response: any) => this.mapUpsertResponse(response.resource)));
    }

    private mapGetResponse(instance: any): any {
        return ResponseMapper.fromGetRequest(instance);
    }

    // TODO: test fromUpsertRequest
    private mapUpsertResponse(instance: any): any {
        return ResponseMapper.fromUpsertRequest(instance);
    }
}

@Injectable()
export class ChassisDataServiceFactory extends DefaultDataServiceFactory {

    /**
     * Create a default {EntityCollectionDataService} for the given entity type
     * @param entityName {string} Name of the entity type for this data service
     */
    create<T>(entityName: string): EntityCollectionDataService<T> {
        return new ChassisDataService<T>(entityName, this.http, this.httpUrlGenerator, this.config);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-resource/src/services/chassis-data.service.ts